import React from 'react';

import styled from 'styled-components';

import StatementStatusIcon from '@components/Transactions/StatementStatusIcon';

const Wrapper = styled.div`
    min-width: 4rem;
    min-height: 4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const getStatementAdditionalText = (statement) => {
    if (statement.isCommission) {
        return 'Agency Fee';
    }
    if (statement.isClientAdvance) {
        return 'Advance';
    }
    return 'Fee';
};

const hasSameInvoiceNumber = (statements) => {
    return statements.every((statement) => statement.InvoiceNumber === statements[0].InvoiceNumber);
};

const MultipleStatementStatus = ({ statements }) => (
    <div className="transaction-status">
        {statements.map((statement) => (
            <StatementStatusIcon
                key={statement.ID}
                additionalText={getStatementAdditionalText(statement)}
                statement={statement}
            />
        ))}
    </div>
);

const SingleStatementStatus = ({ statement }) => (
    <div className="transaction-status">
        <StatementStatusIcon statement={statement} />
    </div>
);

const ProjectSummaryStatusCell = ({ row }) => {
    const statements = row.ClientStatements || row.Transaction?.ClientStatements || [];

    if (statements.length === 0) {
        return <Wrapper></Wrapper>;
    }

    if (statements.length === 1) {
        return (
            <Wrapper>
                <SingleStatementStatus statement={statements[0]} />
            </Wrapper>
        );
    }

    if (statements[0].Status === statements[1].Status) {
        if (statements[0].Status !== 'Invoiced' || hasSameInvoiceNumber(statements)) {
            return (
                <Wrapper>
                    <SingleStatementStatus statement={statements[0]} />
                </Wrapper>
            );
        }
    }

    return (
        <Wrapper>
            <MultipleStatementStatus statements={statements} />
        </Wrapper>
    );
};

export default ProjectSummaryStatusCell;
